// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z8Lg","largestCol":"styles_largestCol__3nTjO","smallestCol":"styles_smallestCol__1-Jv5"};